import { useState, useEffect, useRef, ChangeEvent } from 'react';
import { IconEye, IconEyeCut } from '../../assets/svgs-index';
import { Helper } from '../../core/services/helper/helper.service';
import { InputFieldLabel } from '../../assets/labels/labels';

interface PasswordFieldProps {
  autoComplete?: string;
  password: string;
  onChange: (password: string) => void;
  onValidationComplete?: (isValid: boolean, doNotSubmit: boolean) => void; // New prop to notify parent
  validateNow?: Boolean; 
  styleClass?: string;
  label?: string;
}

const PasswordField = ({ autoComplete, password: initialPassword, onChange, validateNow, onValidationComplete, styleClass, label }: PasswordFieldProps) => {
  const [password, setPassword] = useState(initialPassword);
  const [inputType, setInputType] = useState('password');
  const [isInactive, setIsInactive] = useState(true);
  const [validatedOnBlur, setValidatedOnBlur] = useState(true);

  const passwordInputRef = useRef<HTMLInputElement>(null);

  const handlePasswordValidation = (doNotSubmit = false) => {
    const isValid = Helper.testPasswordRegex(password);
  
    if (passwordInputRef.current) {
      if (isValid) {
        passwordInputRef.current.setCustomValidity('');
        if (onValidationComplete) onValidationComplete(true, doNotSubmit);
      } else {
        passwordInputRef.current.setCustomValidity(InputFieldLabel.passwordPatternError);
        if (onValidationComplete) onValidationComplete(false, doNotSubmit);
      }
      passwordInputRef.current.reportValidity();
    }
  };

  useEffect(() => {
    if (validateNow) {
      handlePasswordValidation();
    }
  // eslint-disable-next-line 
  }, [validateNow]);

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    setValidatedOnBlur(false);
    if (passwordInputRef.current) passwordInputRef.current.setCustomValidity('');
    const { value } = e.target;
    setPassword(value);
    onChange(value);
  };

  const onBlurValidate = () => {
    const dontSubmit = true;
    setIsInactive(true);
    if (!validatedOnBlur) {
      setValidatedOnBlur(true);
      handlePasswordValidation(dontSubmit);}
  }

  const onFocus = () => {
    setIsInactive(false)
  }

  const togglePasswordVisibility = () => {
    setInputType(prevType => (prevType === 'password' ? 'text' : 'password'));
  };

  return (
    <div className={`input-container mt-3 ${styleClass || ''}`}>
      <p className="input-label">{label || 'Password'}</p>
      <div className="password-input-container">
        <input
          ref={passwordInputRef}
          className="input-medium-default password"
          type={inputType}
          title={label || 'Password'}
          value={password}
          //pattern={Helper.passwordRegex}
          onBlur={() => onBlurValidate()}
          onFocus={() => onFocus()}
          onChange={handleChangePassword}
          required={true}
          autoComplete={autoComplete || ''}
        />
        <div className="inside-button-container" onClick={togglePasswordVisibility}>
          <img
            className={`icon-container ${isInactive ? 'icon-inactive' : ''}`}
            src={inputType === 'password' ? IconEye : IconEyeCut}
            alt="Toggle password visibility"
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordField;
